// Footer.jsx
// Common green copyright ribbon. Place it as the LAST child of the page's
// scrolling area so it scrolls into view at the end of the page content
// (same behaviour on every page).
// Styles: ../styles/Footer.css
//
// Optional `style` prop for one-off spacing (e.g. bleeding out of padding).

import React from 'react';
import '../styles/Footer.css';

const Footer = ({ style }) => (
  <div className="common-footer-ribbon" style={style}>
    kinetiqmodel.com | Copyright © 2026 All Rights Reserved.
  </div>
);

export default Footer;